import styled, { keyframes } from "styled-components";

const coloranimate = keyframes`
    0%, 49% {
        background-color: #FF5050;
    }
    50%, 100% {
        background-color: var(--verde)
    }
`

export const Container = styled.header`
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem;
    box-shadow: 0px 1px 5px -1px rgb(0 0 0 / 15%);
    z-index: 5;
    
    button, .link{
        background: none;
        border: none;
        margin: 0 10px;
        
        img{
            width: 2rem;
        }

        span{
            font-size: 2rem;
            font-weight: 900;
            color: var(--darkblue);
            transition: all 0.3s;
        }
        span.new{
            position: absolute;
            width: 0.6rem;
            height: 0.63rem;
            border-radius: 1rem;
            right: 6px;
            top: 9px;
            box-shadow: 1px 1px 3px rgb(0 0 0 / 40%);
            animation: 0.3s ${coloranimate} infinite;
        }
       

        &:hover{
            background: none;
            //filter: invert(55%) sepia(48%) saturate(4559%) hue-rotate(303deg) brightness(102%) contrast(107%);
            span{
                color: var(--pink);
            }
        }

        
    }

    .minithumb{
        width: 2rem;
        height: 2rem;
        border-radius: 50%;
        border: none;
    }

    @media(max-width: 510px) {
        button, .link{
            margin: 0 8px;
        }
    }

    @media(max-width: 493px) {

        .logo{
            width: 8rem;
            height: auto;
        }


        button, .link{
            margin: 0 6px;
            img{
                width: 1.5rem;
            }

            span{
                font-size: 1.5rem;
            }
        
        }
        .minithumb{
            width: 1.5rem;
            height: 1.5rem;
        }
    }
    @media(max-width: 280px) {
      .logo{
            width: 6rem;
            height: auto;
        }
    }
`;

export const ListaALunos = styled.div<{ open: boolean, color?: string}>`
    display: ${props => props.open ? 'block' : 'none'};
    width: 50%;    
    color: ${props => props.color === 'white' ? 'var(--darkblue)' : 'rgba(255,255,255,0.8)'}; 
    position: absolute;
    right: ${props => props.open ? '0' : '-81%'};
    top: 0;
    z-index: 4;
    padding: ${props => props.color === 'white' ? '20px' : '94px 20px 20px 20px'};
    height: 100%;
    max-width: 500px;
    min-width: 280px;
    transition:right 0.2s linear;
    
    a{ text-decoration: none; color: inherit}

    .bgfixed{
        display: block;
        width: 50%;
        background: ${props => props.color === 'white' ? '#fff' : 'var(--darkblue)'};
        color: rgba(255,255,255,0.8);
        position: fixed;
        right: ${props => props.open ? '0' : '-81%'};
        top: 0;
        z-index: 0;
        padding: 20px;
        height: 100%;
        max-width: 500px;
        min-width: 280px;
        transition:right 0.2s linear;
        box-shadow: 1px 1px 5px rgb(0 0 0 / 20%);

    }
    
    .close{
        float: right;
        right: 0;
        margin-bottom: 37px;
        z-index: 5;
    }
    
    h1{font-size: 1.2rem; color: var(--pink); z-index: 1;}
    p{
        z-index: 1;
        width: 82%;
    }


    .boxaluno, .boxregra{
        border-top: 1px solid rgba(255,255,255,0.1);
        background: ${props => props.color === 'white' ? 'rgba(213,209,200,0.3)' : 'transparent'};
        padding: 10px;
        border-radius: 39px;
        display: flex;
        align-items: center;
        cursor: pointer;
        box-shadow: 0 5px 5px -3px rgba(0,0,0,0.1);
        transition: 1s;
        margin-bottom: 10px;
        z-index: 1;
        flex-direction: column;

        .flexcol{
            width: 100%;
            display: flex;
            flex-direction: row;
        }

        &:hover{
            transition: 1s;
            background: rgba(255,255,255,0.05);
        }

        small{
            color: var(--pink);
            display: block;            
        }

        .info{
            width: calc(100% - 80px);
            z-index: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
        }

        .deseja{
            position: absolute;
            background: var(--pink);
            color: var(--darkblue);
            z-index: 2;
            border-radius: 50%;
            display: flex;
            padding: 3px;
            justify-content: center;
            align-items: center;
            top: -2px;
            left: -7px;
            box-shadow: 2px 2px 5px rgba(0,0,0,0.2);

            span{
                font-size: 1.2rem;
                font-weight: 100;
                margin: 1px 2px 1px 0;                
            }
        }
        .nome{ 
            font-size: 1rem; 
            text-transform: capitalize; 
            color: #fff; 
            display:block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        
            span{
                color: var(--pink);
                font-size: 1.1rem;
                line-height: 1px;
                margin: 0 5px;
                top: 3px
            }
        }
        .nothumb{
            background: var(--verde);
            width: 60px;
            height: 60px;
            border-radius: 50%;
            text-align: center;
            align-items: center;
            display: flex;
            justify-content: center;
            border: solid 5px rgba(0,0,0,0.1);
            font-size: 1.8rem;
            font-weight: 900;
            text-shadow: 0px 3px 0 rgb(255,255,255,0.2);
            margin-right: 10px;
            text-transform: uppercase;
        }
        .thumb{            
            width: 60px;
            height: 60px;
            border-radius: 50%;
            display: flex;            
            margin-right: 10px;
        }

        .flex{
            display: flex;
            justify-content: space-between;
            align-items: baseline;
        }
        .edicao{
            font-size: 0.67rem;
            color: var(--verde);
         
            .off, strong{color: var(--pink)}
            .on{color: #fff}
        }


 
    }

    .boxregra{
        
        align-items: flex-start;
        border-top-left-radius: 1rem;
        border-top-right-radius: 1rem;
        flex-direction: row;
        cursor: default;

        small{            
            display: inline-block;            
        }

        p{
            display: block;
            margin: 10px 0 0 0;
            width: auto;
            text-align: justify
        }

        .diaregra{
            display: block;
            position: relative;
            margin-right: 10px;
            

            span.material-icons{
                color: var(--verde);
                font-size: 3.5rem;
                z-index: 0;
            }
            .dia{
                position: absolute;
                z-index: 1;
                left: 1rem;
                font-size: 1.5rem;
                font-weight: 900;
                top: 1.2rem;
                color: var(--verde)
            }
            .mes{
                color: var(--verde);
                display: block;
                align-items: center;
                text-align: center;
                font-size: 0.7rem;
                text-transform: uppercase;
                top: -0.2rem
            }
        }

        .statusregra{
            display: inline-block;
            top: 4px;
            color: var(--verde);
            font-size: 0.8rem;
            text-align: center;
            width: 51px;
        }

        pre{
            margin-top: 10px;
            white-space: break-spaces;
            font-family: 'Roboto Condensed', Calibri, sans-serif;
            opacity: 0.8;
        }

        .edit{ 
            padding: 5px 10px;
            top: 5px;
            margin-left: 10px;
            right: 8px;
            position: absolute;
            z-index: 9;
        }
        
    }
    .passado{
        opacity: 0.8;
        &:hover{
            opacity: 1;
        }
    }

    @media(max-width: 890px){
        .boxaluno {
            .flex{
                flex-direction: column;
            }
            .edicao{
                line-height: 1rem;
                bottom: -4px;
                
            }
        }
    }
    @media(max-width: 280px){
      padding: 72px 20px 20px 20px;
    }

`